import { VeeValidate } from '../vue.bundle';

VeeValidate.Validator.extend('fwEmail', {
    getMessage: field => '*',
    validate: (value) => {
        let pattern = /^[\w!\'.-]*[a-zA-Z0-9'_]@[\w\.-]*[a-zA-Z0-9]\.[a-zA-Z][a-zA-Z\.]*[a-zA-Z]$/;
        return pattern.test(value);
    }
});

VeeValidate.Validator.extend('validInput', {
    getMessage: field => '*',
    validate: (value) => {
        let pattern = /^[^<>/`^]*$/;
        return pattern.test(value);
    }
});

export default {
    name: 'RequestAccessModule',
    template: '#cmp-request-access',
    data() {
        return {
            firstName: '',
            surname: '',
            email: '',
            company: '',
            title: '',
            phone: '',
            country: '',
            comments: '',
            captcha: '',
            captchaImg: '/captcha/requestaccess',
            countries: [],
            showSuccess: false,
            showError: false,
            showForm: true,
            submitting: false,
            requestVerificationToken: '',
            NonZDC: false
        };
    },
    methods: {
        refreshCaptcha() {
            let self = this;
            let date = new Date();
            self.captchaImg = '/captcha/requestaccess?' + date.getTime();
        },
        requestAccess(elem) {
            let self = this;

            self.$validator.validateAll().then((valid) => {
                if (valid) {
                    self.submitting = true;
                    let requestAccess = {
                        firstName: self.firstName,
                        surname: self.surname,
                        email: self.email,
                        country: self.country,
                        title: self.title,
                        company: self.company,
                        phone: self.phone,
                        comments: self.comments,
                        captcha: self.captcha
                    };

                    $.ajax({
                        type: 'post',
                        url: '/api/account/requestaccess',
                        dataType: 'json',
                        contentType: 'application/json',
                        data: JSON.stringify(requestAccess),
                        headers: { 'X-CSRF-TOKEN': self.requestVerificationToken }
                    })
                        .done((r) => {
                            self.showSuccess = true;
                            self.showForm = false
                        })
                        .fail((r) => {
                            let resp = r.responseJSON || {};
                            if (r.status === 400) {
                                if (resp.reason === 'captcha') {
                                    self.$validator.errors.add('captcha', 'wrong', 'failed');
                                } else {
                                    self.showError = true;
                                }
                            } else {
                                self.showError = true;
                            }

                            self.submitting = false;
                        })
                    return;
                }
            });
        },
        getCountries() {
            let self = this;
            $.getJSON('/api/countries')
                .done((r) => {
                    self.countries = r;
                })
        },
        setRequestVerificationToken() {
            this.requestVerificationToken = $('input[name=__RequestVerificationToken]').val();
        }
    },
    created() {
        this.setRequestVerificationToken();
        this.getCountries();
        toggleRegisterLoginMsg(false);
    }
}



// WEBPACK FOOTER //
// ./src/scripts/vue/components/RequestAccess.js